import { DEFAULT_SECTIONS, ProductTypeConfig } from '../types';

/**
 * 1320 - Bonus Outperformance Certificate
 * Bonus variant (detected by "Bonus" in product name)
 *
 * At a Glance: No coupon, shows Upside, Upside participation, Downside, Downside participation, Bonus level, Cap level
 * Barrier: Keep as is (enabled)
 * Underlyings: Keep as is
 */
export const config1320Bonus: ProductTypeConfig = {
  code: '1320',
  callableType: 'Bonus',
  name: 'Bonus Outperformance Certificate',
  sections: {
    ...DEFAULT_SECTIONS,

    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        coupon: false, // No coupon
        upside: true, // Basket Type up
        upsideParticipation: true, // Participation up %
        downside: true, // Basket type down
        downsideParticipation: true, // Participation down %
        issuePrice: false,
        bonusLevel: true, // Bonus level
        capLevel: true, // Cap level
        issuePricePct: false,
        settlementType: true,
      },
    },

    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: true, // Keep barrier section
      props: {
        barrierType: true,
        strikeLevel: true,
        strikeDistance: true,
        barrierLevel: true,
        barrierDistance: true,
        barrierHit: true,
      },
    },

    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      props: {
        ...DEFAULT_SECTIONS.underlyings.props,
        barrierLevel: true,
        barrierDistance: true,
      },
    },

    coupons: {
      enabled: false, // No coupons
      props: {},
    },

    earlyRedemption: {
      enabled: false, // No early redemption
      props: {},
    },

    performance: {
      enabled: true,
      props: {},
    },

    couponDetails: {
      enabled: false,
      props: {},
    },
  },
};

/**
 * 1320 - Airbag Certificate
 * Airbag variant (detected by "Airbag" in product name)
 *
 * At a Glance: No coupon, shows Upside, Upside participation, Downside, Downside participation, Bonus level, Cap level, Strike, Strike distance
 * Barrier: Disabled (removed)
 * Underlyings: Keep as is
 */
export const config1320Airbag: ProductTypeConfig = {
  code: '1320',
  callableType: 'Airbag',
  name: 'Airbag Certificate',
  sections: {
    ...DEFAULT_SECTIONS,

    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        coupon: false, // No coupon
        upside: true, // Basket Type up
        upsideParticipation: true, // Participation up %
        downside: true, // Basket type down
        downsideParticipation: true, // Participation down %
        bonusLevel: true, // Bonus level
        capLevel: true, // Cap level
        strikeLevel: true, // Strike
        issuePricePct: false,
        issuePrice: false,
        settlementType: true,
      },
    },

    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: false, // No barrier section for Airbag
    },

    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      props: {
        ...DEFAULT_SECTIONS.underlyings.props,
        barrierLevel: false, // No barrier in underlyings
        barrierDistance: false,
      },
    },

    coupons: {
      enabled: false,
      props: {},
    },

    earlyRedemption: {
      enabled: false,
      props: {},
    },

    performance: {
      enabled: true,
      props: {},
    },

    couponDetails: {
      enabled: false,
      props: {},
    },
  },
};


/**
 * 1320 - Bonus Certificate
 */
export const config1320BonusCertificate: ProductTypeConfig = {
  code: '1320',
  callableType: 'Bonus',
  name: 'Bonus Certificate',
  sections: {
    ...DEFAULT_SECTIONS,
    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        coupon: false, // No coupon
        upside: true, // Basket Type up
        upsideParticipation: true, // Participation up %
        downside: true, // Basket type down
        downsideParticipation: true, // Participation down %
        issuePrice: false,
        bonusLevel: true, // Bonus level
        capLevel: false, // Cap level
        issuePricePct: false,
        settlementType: false,
      },
    },
    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: true, // Keep barrier section
      props: {
        barrierType: true,
        strikeLevel: true,
        strikeDistance: true,
        barrierLevel: true,
        barrierDistance: true,
        barrierHit: true,
      },
    },
    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      props: {
        ...DEFAULT_SECTIONS.underlyings.props,
        barrierLevel: true,
        barrierDistance: true,
      },
    },
    coupons: {
      enabled: false, // No coupons
      props: {},
    },
    earlyRedemption: {
      enabled: false, // No early redemption
      props: {},
    },
    performance: {
      enabled: true,
      props: {},
    },
    couponDetails: {
      enabled: false,
      props: {},
    },
  },
};
